import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import Home from '@/views/Home.vue';
import Gallery from '@/views/Gallery.vue';
import NotFound from '@/views/NotFound.vue';
import { getJWTFromURL, getRedirectUrl } from '@/services/token';
import { useAuth } from '@/hooks';
import { getPathFromUrl, getQueryFromUrl } from '@/utils';
import { ParsedQuery } from 'query-string';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: '/gallery/:id',
    name: 'Gallery',
    component: Gallery,
    meta: { requiresAuth: false },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { requiresAuth: false },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(to => {
  // if land on the returned url with access_token from identity
  if (to.path.startsWith('/access_token')) {
    // redirect after login
    // after login in identity, it will auto redirect to the domain/access_token=TOKEN
    const isAuthRedirectPath: boolean = getJWTFromURL() !== null;
    const redirectUrl: string = getRedirectUrl();
    const redirectPath: string = getPathFromUrl(redirectUrl);
    const redirectQuery: ParsedQuery = getQueryFromUrl(redirectUrl);

    if (isAuthRedirectPath) {
      return {
        path: redirectPath,
        query: redirectQuery,
      };
    } else {
      return {
        path: '/',
      };
    }
  }

  if (to.meta.requiresAuth) {
    // check auth
    const { checkAuth } = useAuth();

    checkAuth();
  }
});

export default router;
